<template lang="pug">
  .column-header-wrapper(:title="column" :style="{'grid-column': index + 1}" v-ptt-popover.bottom.hover="{content: mensagemAoPassarCursor}")
    template(v-if="pesquisavel")
      .group
        template(v-if="!options")
          template(v-if="mask")
            input(
              v-mask="mask"
              type='text'
              required=''
              v-model="searchValue"
              :placeholder="placeholder"
              :name="nomeDeDominioDoFiltro"
              :aria-label="column"
              autocomplete="off"
              ref="input"
              @keyup.down="() => $emit('focusFirstRow')"
            )
          template(v-else)
            input(
              type='text'
              required=''
              v-model="searchValue"
              :placeholder="placeholder"
              :name="nomeDeDominioDoFiltro"
              :aria-label="column"
              autocomplete="off"
              ref="input"
              @keyup.down="() => $emit('focusFirstRow')"
            )

          span.highlight
          label(:title="column") {{ column }}

        template(v-else)
          .option-column-name.to-click.noselect(@click="switchShowOptions") {{ column }}

          transition(name="bounce2")
            .options-container(v-if="showOptions", v-click-outside="closeOptions")
              .displayBlock(
                v-for="op in options" 
                @click="setOptionsSearch(op)" 
                :class="{'margin-bottom': !op.iconClass}"
              )
                span(v-if="op.iconClass" :class="op.iconClass" @click="setOptionsSearch(op)")
                span {{ op.text }}

      .sort-icon.fs-13.fw-bold.icone-linha-seta-baixo.to-click(
        v-if="!options && ordenavel"
        :class="{active: currentFieldSort.field === field}"
        :style="currentFieldSort.field === field && currentFieldSort.order === 'desc' ? 'transform: rotate(180deg)' : ''",
        @click="switchOrder"
      )

      .filter.icone-linha-filtro.to-click(
        :style="searchValue ? 'opacity: 1; color: var(--status-sucesso)' : ''"
        @click="() => $refs.input.focus()"
      )
    template(v-else)
      .coluna(:class="[classeDeCentralizado]")
        label(:title="column") {{ column }}

</template>

<script>
export default {
  name: 'ColumnHeader',
  inject: {
    smartTableHeaderRegistry: {
      default: null
    }
  },
  props: {
    column: {type: String, required: true},
    field: {type: String, required: true},
    index: {type: Number, required: true},
    options: {type: Array, required: false, 'default': null},
    search: {type: String, required: true},
    mask: {type: String, required: false, 'default': null},
    placeholder: {type: String, required: false, 'default': ''},
    currentFieldSort: {type: Object, required: true},
    pesquisavel: {type: Boolean, 'default': true},
    ordenavel: {type: Boolean, 'default': true},
    tituloCentralizado: {type: Boolean, 'default': false},
    mensagemAoPassarCursor: {type: String, required: false, 'default': null}
  },
  data () {
    return {
      showOptions: false,
      headerRegistration: null
    }
  },
  created () {
    const vm = this

    this.headerRegistration = {
      get field () {
        return vm.field
      },
      focusSearch: (...params) => vm.focusSearch(...params)
    }
  },
  computed: {
    /**
     * O endereço de domínio deste filtro, estável entre renders.
     *
     * O `label {{ column }}` ao lado não é associado por `for`, então quem lê a
     * tela de fora não sabia a que coluna este campo pertence — e o
     * preenchimento pela conversa recusava com `campo_nao_encontrado` em toda
     * tela montada sobre `SmartTable` (medido em 20/09/2026, na de jornadas).
     *
     * `field` é a chave de máquina da coluna; o prefixo separa o filtro do
     * campo homônimo de um formulário na mesma tela.
     */
    nomeDeDominioDoFiltro () {
      return this.field ? `filtro-${this.field}` : null
    },
    searchValue: {
      get () {
        return this.search
      },
      set (value) {
        this.$emit('search', this.field, value)
      }
    },
    classeDeCentralizado () {
      return this.tituloCentralizado
        ? 'centralizado'
        : ''
    }
  },
  methods: {
    switchOrder () {
      this.$emit(
        'order',
        this.field,
        this.currentFieldSort.field === this.field && this.currentFieldSort.order === 'asc' ? 'desc' : 'asc'
      )
    },
    focusSearch (text = '', merge = true) {
      // used for parent be able to focus my input search
      if (this.$refs.input) this.$refs.input.focus()
      if (text) {
        this.searchValue = merge ? this.searchValue + text : text
      }
    },
    switchShowOptions () {
      this.showOptions = !this.showOptions
    },
    closeOptions () {
      this.showOptions = false
    },
    setOptionsSearch (item) {
      this.searchValue = item?.id || item.text
      this.closeOptions()
    }
  },
  mounted () {
    this.smartTableHeaderRegistry?.registerHeader?.(this.headerRegistration)
  },
  beforeUnmount () {
    this.smartTableHeaderRegistry?.unregisterHeader?.(this.headerRegistration)
  },
  watch: {
    field () {
      this.smartTableHeaderRegistry?.unregisterHeader?.(this.headerRegistration)
      this.smartTableHeaderRegistry?.registerHeader?.(this.headerRegistration)
    }
  }
}
</script>

<style scoped lang="scss">
.column-header-wrapper {
  display: grid;
  align-items: center;
  grid-template-columns: minmax(0, 1fr) 24px 24px;
  position: relative;
  min-height: 44px;
  padding-right: 8px;
  color: var(--texto-suave);
  font-family: var(--texto-tipografia, var(--front-font));
  line-height: 16px;

  .centralizado {
    text-align: center;
  }

  .sort-icon {
    transition: transform 0.2s ease-out;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 24px;
    min-height: 24px;
    margin-right: 0;

    &:not(.active) {
      color: var(--borda);
    }
  }

  .filter {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 24px;
    min-height: 24px;
    margin-right: 0;
    grid-column: 3 / 4;
    opacity: 0;
    color: var(--acao-primaria);
    transition: opacity 0.2s linear, color 0.2s linear;
  }

  &:hover, &:focus-within {
    .filter {
      opacity: 1;
    }
  }
  .coluna {
    position:relative;
    grid-column: 1 / 4;
    display: flex;
    min-width: 0;
    align-items: center;
    min-height: 100%;
    /* Label Design — caption: texto suave, peso 500, tamanho caption */
    label {
      max-width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      color: var(--texto-suave);
      font-size: 13px;
      font-weight: 500;
      line-height: 16px;
      pointer-events:none;
      align-self: center;
    }
  }
  .group {
    position:relative;
    align-self: center;
    grid-column: 1 / 2;
    min-width: 0;

    input {
      padding: 14px 5px 4px 0;
      display:block;
      width:100%;
      border:none;
      color: var(--texto-forte);
      font-family: var(--texto-tipografia, var(--front-font));
      font-size: 13px;
      font-weight: 400;
      line-height: 18px;
      background: transparent;

      &::selection {
        background-color: var(--acao-primaria);
        color: var(--texto-em-acao);
      }

      &:not(:focus) {
        &::placeholder {
          color: transparent !important;
        }
      }
    }
    input:focus {
      outline:none;
    }
    /* Label Design — caption: recua visualmente para dar destaque ao dado */
    label {
      color: var(--texto-suave);
      font-size: 13px;
      font-weight: 500;
      line-height: 16px;
      position:absolute;
      pointer-events:none;
      top: 13px;
      transition:0.2s ease all;
      display: grid;
      grid-template-columns: minmax(0, 1fr) min-content;
      max-width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      grid-column-gap: 3px;
      z-index: 100;

      .icone-linha-seta-baixo {
        margin-top: 2px;
        z-index: 100;
      }

    }

    .option-column-name {
      max-width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      color: var(--texto-suave);
      font-size: 13px;
      font-weight: 500;
      line-height: 16px;
      padding-bottom: 0;
    }
    /* Active state — ação primária ao focar */
    input:focus ~ label, input:valid ~ label {
      top: 0;
      font-size: 12px;
      color: var(--acao-primaria);
      background-color: var(--superficie-papel);
      margin-left: -4px;
      padding: 0 7px 0 4px;
    }

    /* active state */
    input:focus ~ .bar:before, input:focus ~ .bar:after {
      width: 50%;
    }
    /* Highlighter */
    .highlight {
      position:absolute;
      height:60%;
      width:100px;
      top:25%;
      left:0;
      pointer-events:none;
      opacity:0.5;
    }
    /* active state */
    input:focus ~ .highlight {
      animation:inputHighlighter 0.3s ease;
    }

    .options-container {
      display: flex;
      flex-direction: column;
      position: absolute;
      top: 30px;
      left: -10px;
      width: fit-content;
      z-index: 1;
      background-color: var(--superficie-papel);
      box-shadow: 0 8px 20px var(--borda);
      padding: 4px 0;
      border-bottom: 2px solid var(--acao-primaria);
      border-left: 2px solid var(--acao-primaria);
      border-right: 2px solid var(--acao-primaria);
      overflow: hidden;

      div {
        display: flex;
        align-items: center;
        white-space: nowrap;
        cursor: pointer;

        &:hover {
          span {
            background-color: var(--superficie-sutil);
          }
        }

        span:first-child:not(:last-child) {
          flex: 0 0 32px;
          justify-content: center;
          text-align: center;
        }

        span {
          width: auto;
          min-height: 28px;
          display: inline-flex;
          align-items: center;
          padding: 4px 8px;
        }

        span:last-child {
          flex: 1 0 auto;
        }
      }
    }
  }
}

.margin-bottom{
  margin-bottom: 3px;
}

@keyframes complete-down {
  0% {
    height: 0%
  }
  100% {
    height: 100%
  }
}

.bounce2-enter-active {
  animation: complete-down  .2s;
}
.bounce2-leave-active {
  animation: complete-down  .2s reverse;
}

</style>
